import { useState } from 'react';
import './topbar.css'
import { useNavigate } from 'react-router-dom'

const TIME_ZONE = +10;

export function TopBar() {
    const nav = useNavigate()
    const [getTimeStr, setTimeStr] = useState(TimeDisplay())

    const UpdateTime = () => {
        setTimeout(() => {
            setTimeStr(TimeDisplay())
            UpdateTime()
        }, 1000*60)
    }
    UpdateTime()

    return (
        <div className="topbar">
            <div className="topbar_apps">
                <button onClick={() => {nav("/")}}> main page </button>
                <button onClick={() => {nav("/bank")}}> bank </button>
                <button onClick={() => {nav("/radio")}}> radio </button>
            </div>
            <div className="topbar_big">
                <h1> Main Page </h1>
            </div>
            <div className="topbar_big">
                <h1> {getTimeStr} </h1>
            </div>
        </div>
    );

    function TimeDisplay() {
        let hour = Math.floor(Date.now()/1000/60/60 % 24 + TIME_ZONE);
        let min = Math.floor(Date.now()/1000/60) % 60;
        
        if(`${min}`.length == 1) {
            min = `0${min}`
        }

        if(`${hour}`.length == 1) {
            hour = `0${hour}`
        }

        return `${hour}:${min}`
    }
}